import { Theme } from './symbols';

export const standardTheme: Theme = {
  name: 'standard',
  properties: {
    '--primary-color': 'rgba(72, 91, 157, 1)',
    // '--primary-color': '#d9534f',
    '--primary-light': 'rgba(72, 91, 157,0.1)',
    '--secondary-color': 'rgba(136, 136, 136, 1)',
    '--complementary-color': '#444',
  }
};

